import { HolderOutlined } from "@ant-design/icons";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import React, { memo, useMemo } from "react";
import ChapterCard from "../../chapter-card";
import LessonCard from "../../lesson-card";
import UnitCard from "../../unit-card";
import { globalStore } from "../../../../../stores/stores";

interface Props {
  item: any;
  dataConfig: any;
  type: "CHAPTER" | "LESSON" | "RESOURCE";
}

const DragItemContent = memo(({ item, type, dataConfig }: Props) => {
  const { reload, setReload } = globalStore();
  switch (type) {
    case "CHAPTER":
      return (
        <ChapterCard
          data={item}
          handleGetDetail={() => setReload(!reload)}
        />
      );
    case "LESSON":
      return (
        <LessonCard
          data={item}
          dataConfig={dataConfig}
          handleGetDetail={() => setReload(!reload)}
        />
      );
    case "RESOURCE":
      return (
        <UnitCard
          data={item}
          handleGetDetail={() => setReload(!reload)}
        />
      );
    default:
      return <div>{item.name}</div>;
  }
}
);

const DragItem = ({ item, type, dataConfig }: Props) => {
const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: item.id,
  });

  const style: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.4 : 1,
    background: "#fff",
    borderRadius: 4,
    cursor: "default",
    padding: 12,
    borderBottom: "1px solid #f0f0f0",
    marginLeft: type === "RESOURCE" ? "24px" : undefined,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <div className="flex align-center">
        <div
          {...attributes}
          {...listeners}
          style={{
            cursor: "grab",
            padding: "4px 8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <HolderOutlined />
        </div>

        <div style={{ padding: "4px 8px", flexGrow: 1 }}>
          <DragItemContent item={item} type={type} dataConfig={dataConfig} />
        </div>
      </div>
    </div>
  );
};

export default memo(DragItem, (prev, next) => {
  return (
    prev.item.id === next.item.id &&
    JSON.stringify(prev.item) === JSON.stringify(next.item) &&
    prev.type === next.type &&
    prev.dataConfig === next.dataConfig
  );
});